import React from 'react';
import { Link } from 'react-router-dom';
import { Button, List, Popup } from 'semantic-ui-react';

import { NombrePersonal as NombrePersonalDTO } from 'src/api/protocolo';
import { NombrePersonal } from 'src/componentes';

interface ItemListaProps {
    etiqueta: React.ReactNode;
    valor: React.ReactNode;
    color?: string;
}
const ItemLista: React.FunctionComponent<ItemListaProps> = props => {
    const { etiqueta, valor, color } = props;
    return (
        <List.Item>
            {etiqueta}:{' '}
            <span style={{ color }}>
                <b>{valor}</b>
            </span>
        </List.Item>
    );
};

export type Props = Readonly<{
    id: number;
    nombre: string;
    sala: string;
    inscritos: number;
    capacidad: number;
    sobrecupo: number;
    profesor?: { nombre: NombrePersonalDTO };
}>;

const Curso: React.FunctionComponent<Props> = props => {
    const { id, nombre, sala, profesor } = props;

    const style: React.CSSProperties = {
        backgroundColor: colorDelBloque(nombre),
        width: '8.4em',
        border: '1px solid #444',
        marginTop: '1px',
        marginBottom: '1px',
    };

    return (
        <Popup
            trigger={
                <Link to={`cursos/${id}`}>
                    <Button style={style} active size='mini'>
                        {nombre}
                        <br />
                        {profesor ? (
                            <NombrePersonal nombre={profesor.nombre} patron='%N %p' />
                        ) : (
                            <>&mdash;</>
                        )}
                    </Button>
                </Link>
            }
            flowing
            closeOnEscape
            hideOnScroll
        >
            <Popup.Header>{nombre}</Popup.Header>
            <Popup.Content>
                <List>
                    <ItemLista etiqueta='Sala' valor={sala} />
                    {profesor ? (
                        <ItemLista
                            etiqueta='Profesor'
                            valor={<NombrePersonal nombre={profesor.nombre} patron='%N %P %m' />}
                        />
                    ) : (
                        <ItemLista etiqueta='Profesor' valor='No asignado' color='red' />
                    )}
                </List>
            </Popup.Content>
        </Popup>
    );
};

function colorDelBloque(bloque: string) {
    if (bloque.startsWith('M')) return '#ff0000';
    if (bloque.startsWith('L')) return '#0081b8';
    if (bloque.startsWith('H')) return '#fbfb00';
    return '#47ba00';
}

export default Curso;



// WEBPACK FOOTER //
// ./src/modulos/Asistencia/paginas/HorarioCompleto/Curso.tsx